import { MinusCircleIcon } from './MinusCircleIcon';

/**
 * author: Google
 * id DDEB98E7-E016-44CA-8DE7-A31969C2CC04
 * name minus-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-circle.svg
 * tags
 * - Transportation + Road 
 * - Medical / Hospital 
 * - Form 
 */
export const DoNotEnterIcon = MinusCircleIcon;
export default DoNotEnterIcon